import './App.css';
import { Main, Authorization, Registration, RegistrationFinal, UserProfile, CurrentBiddings, CompletedBiddings, Rules } from './pages';
import { Layout } from './components';
import {
	createBrowserRouter,
	RouterProvider,
  	redirect
} from "react-router-dom";
import Cookies from 'universal-cookie';
import { setIsAuth } from './store/isAuthStore'
import { jwtDecode } from 'jwt-decode';
import { useEffect } from 'react';
import { getCurrentUser } from './components/api';
import { setUserData } from './store/userData';

const isTokenExpired = (token) => {
	if (!token) {
		return true; // Если токена нет, он "просрочен"
	}
	try {
		const decodedToken = jwtDecode(token);
		const currentTime = Date.now() / 1000;
		return decodedToken.exp < currentTime;
	} catch (error) {
		console.error("Error decoding token:", error);
		return true;
	}
};

const cookies = new Cookies();
const token = cookies.get('token');
let isAuth = !isTokenExpired(token);
setIsAuth(isAuth);

const router = createBrowserRouter([
	{
		loader: async () => {
			if (!isAuth)
				throw redirect("/authorization");
			return null;
		},
		children: [
			{ path: "/", element: <Main /> },
			{ path: "/userProfile", element: <UserProfile /> },
			{ path: "/rules", element: <Rules /> }
		]
	},
	{
		path: "authorization",
		element: <Authorization />
	},
	{
		path: "/registration",
		element: <Registration />,
	},
	{
		path: "/registrationFinal",
		element: <RegistrationFinal />
	},
	{
		path: "/userProfile",
		element: <UserProfile/>
	},
	{
		path: "/rules",
		element: <Rules/>
	},
  {
		path: "/currentBiddings",
		element: <CurrentBiddings />
	},
  {
		path: "/completedBiddings",
		element: <CompletedBiddings />
	}
]);

function App() {

	useEffect(() => {
		if (isAuth) {
			getCurrentUser().then(data => {
				setUserData(data);
			})
				.catch(error => {
					setIsAuth(false);
					if (error.response.status !== 401)
						console.log(error)
				})
		}
	}, [isAuth]);

	return (
		<div className="App">
			<Layout>
				<RouterProvider router={router} />
			</Layout>
		</div>
	);
}

export default App;
